import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Actions from "../../stores/actions";
import { Typography } from "@mui/material";
import ProgressBar from "./progressBar";
import axios from "axios";

const getZendeskAccessToken = async (
  jwtToken,
  domain,
  subdomain,
  code,
  state
) => {
  try {
    // const ZENDESK_CALLBACK_URL = "https://x58h3cokz7.execute-api.us-east-1.amazonaws.com/api/zendesk/callback"; //DEV
    const ZENDESK_CALLBACK_URL =
      "https://c7s4wl56td.execute-api.us-east-1.amazonaws.com/api/zendesk/callback"; //PROD
    const response = await axios.post(
      ZENDESK_CALLBACK_URL,
      {
        subdomain: subdomain,
        code: code,
        state: state,
      },
      {
        headers: {
          "x-parent-origin": domain,
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    return {
      zendeskAccessToken: response?.data?.access_token,
      zendeskRefreshToken: response?.data?.refresh_token,
    };
  } catch (error) {
    console.error("Access Token Generation Failed Due To:", error);
    return null;
  }
};

const authorizeZendeskSessionAndGetAccessToken = async (
  domain,
  subdomain,
  code,
  state
) => {
  try {
    // const AUTHORIZE_ZENDESK_SESSION_URL = "https://23w0tdvkbf.execute-api.us-east-1.amazonaws.com/api/zendesk/authorizer"; //DEV
    const AUTHORIZE_ZENDESK_SESSION_URL =
      "https://fpv16eu6v3.execute-api.us-east-1.amazonaws.com/api/zendesk/authorizer"; //PROD
    const response = await axios.post(
      AUTHORIZE_ZENDESK_SESSION_URL,
      {
        subdomain: subdomain,
      },
      {
        headers: {
          "x-parent-origin": domain,
        },
      }
    );
    return await getZendeskAccessToken(
      response?.data?.token,
      domain,
      subdomain,
      code,
      state
    );
  } catch (error) {
    console.error("Session Authorization Failed Due To:", error);
    return null;
  }
};

const LandingApp = (props) => {
  const dispatch = useDispatch();

  const responseMessage = useSelector(
    (state) => state.LandingReducers.responseMessage
  );
  const isLoaderActive = useSelector(
    (state) => state.LandingReducers.isLoaderActive
  );

  useEffect(() => {
    if (window.location) {
      dispatch(Actions.changeLoaderState(true));
      // Extracting domain from the ancestor origin
      let domain = window.location.ancestorOrigins[0] || "";
      // Nothing in ancestor origin, look for referrer
      if (domain === "") {
        domain = document.referrer;
      }
      let ele = domain.includes("//") ? domain.split("//")[1] : "";
      let ticketingSystem = "";
      let transactionId = Array.from(Array(20), () =>
        Math.floor(Math.random() * 36).toString(36)
      ).join("");
      let subdomain = ele.includes(".") ? ele.split(".")[0] : "";
      const searchParams = new URLSearchParams(window.location.search);
      if (ele.includes(".salesforce.com")) {
        // Handle Salesforce logic
        ticketingSystem = "salesforce";
        let params = new URLSearchParams(window.location.search);
        let code = params.get("code");
        dispatch(
          Actions.initiateOnboarding(
            transactionId,
            subdomain,
            code,
            ticketingSystem,
            ""
          )
        );
      } else if (ele.includes("zendesk")) {
        // Handle Zendesk logic
        ticketingSystem = "zendesk";
        const params = new URLSearchParams(window.location.search);
        const error = params.get("error");
        const code = params.get("code");
        const state = params.get("state");
        if (error) {
          console.error(
            `${error} - Error Received In URL Query Params From Zendesk`
          );
          dispatch(
            Actions.setResponseMessage(
              "Invalid URL Query Params Received From Zendesk"
            )
          );
          dispatch(Actions.changeLoaderState(false));
        } else {
          const getToken = async () => {
            const { zendeskAccessToken, zendeskRefreshToken } =
              await authorizeZendeskSessionAndGetAccessToken(
                domain,
                subdomain,
                code,
                state
              );
            if (zendeskAccessToken) {
              dispatch(
                Actions.initiateOnboarding(
                  transactionId,
                  subdomain,
                  zendeskAccessToken,
                  ticketingSystem,
                  zendeskRefreshToken
                )
              );
            } else {
              console.error("OAuth token exchange failed");
              dispatch(
                Actions.setResponseMessage(
                  "Unable To Generate Zendesk Access Token"
                )
              );
              dispatch(Actions.changeLoaderState(false));
            }
          };
          getToken();
        }
      } else if (searchParams.get("subDomain").includes(".freshdesk.com")) {
        subdomain = searchParams.get("subDomain").split(".freshdesk.com")[0];
        let apiKey = searchParams.get("apiKey");
        ticketingSystem = "freshdesk";
        dispatch(
          Actions.initiateOnboarding(
            transactionId,
            subdomain,
            apiKey,
            ticketingSystem,
            ""
          )
        );
      } else if (searchParams.get("subDomain").includes(".gorgias.com")) {
        subdomain = searchParams.get("subDomain").split(".gorgias.com")[0];
        let apiKey = searchParams.get("apiKey");
        ticketingSystem = "gorgias";
        dispatch(
          Actions.initiateOnboarding(
            transactionId,
            subdomain,
            apiKey,
            ticketingSystem,
            ""
          )
        );
      }
    }
  }, [dispatch]);

  return (
    <div className="App">
      <div className="App-header">
        <img className="App-logo" src={"images/readyly_logo.png"} alt="logo" />
      </div>
      {isLoaderActive ? (
        <div style={{ width: "400px", margin: "auto" }}>
          {" "}
          <ProgressBar />{" "}
        </div>
      ) : (
        <div className="App-loader">
          <Typography
            style={{
              color: "#152938",
              fontSize: 20,
              fontWeight: 500,
              marginTop: 20,
              fontFamily: "sans-serif",
            }}
          >
            {responseMessage}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default LandingApp;
